import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import MediaQuery from '../common/media_query';
import RelatedEntriesLink from './related_entries_link';
import RosettaFormattedMessage from '../common/rosetta_formatted_message';
import withViewportScrollTracking from '../hocs/withViewportScrollTracking';


const related = (relatedEntries, onRightRailArticle, shouldShowImages) => {
  return relatedEntries.map(({ id, url, hero_shorter_title, title, opener_images }, index) => {
    const relatedClass = classNames('related-entry', {
      'has-border': index > 0 && relatedEntries.length > 1,
      'single-entry': onRightRailArticle && relatedEntries.length === 1,
      'double-entry': onRightRailArticle && relatedEntries.length === 2
    });

    return (
      <div className={relatedClass} key={id}>
        <RelatedEntriesLink
          id={id}
          url={url}
          title={hero_shorter_title || title}
          cellIndex={index}
          opener_images={opener_images}
          shouldShowImages={shouldShowImages}
        />
      </div>
    );
  });
};

export const RelatedEntries = ({
  relatedEntries,
  onRightRailArticle,
  onSlideshowArticle,
  hasCondensedStyling
}) => {
  // There should never be more than 3
  relatedEntries = relatedEntries.slice(0, 3);
  const shouldShowImages = !onSlideshowArticle && !hasCondensedStyling;
  const containerClassNames = hasCondensedStyling
    ? 'related-entries-condensed'
    : classNames('related-entries-container', {
      'single-entry': onRightRailArticle && relatedEntries.length === 1,
      'with-images': shouldShowImages
    });

  return (
    <div className={containerClassNames}>
      <div className="related-entries-header">
        <RosettaFormattedMessage parentFilename={__filename}
          id="header"
          description="Appears above the related entries section below articles"
          defaultMessage="Related Stories"
        />
      </div>
      <MediaQuery breakpoint="notMobile">
        <div className="related-entries">
          {related(relatedEntries, onRightRailArticle, shouldShowImages)}
        </div>
      </MediaQuery>
      <MediaQuery breakpoint="mobile">
        <div className="related-entries-column">
          {related(relatedEntries, onRightRailArticle, shouldShowImages)}
        </div>
      </MediaQuery>
    </div>
  );
};

RelatedEntries.propTypes = {
  relatedEntries: PropTypes.array.isRequired,
  onRightRailArticle: PropTypes.bool,
  onSlideshowArticle: PropTypes.bool,
  hasCondensedStyling: PropTypes.bool
};

const decorator = withViewportScrollTracking({
  eventParams: () => [
    'Scroll Depth',
    'Scroll',
    'Related Stories Module'
  ]
});

export default decorator(RelatedEntries);
